import {Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
// Services
import {RewardsSummaryService} from '../../../shared/services/rewards-summary.service';
import {RewardService} from '../../../shared/services/reward.service';
// Data model
import {RewardModel} from '../../../shared/models/data.model';
import {ClipService} from '../../../shared/services/clip.service';
import {BsModalService, BsModalRef} from 'ngx-bootstrap/modal';
import {properties} from '../../../../environments/properties';
import {ParamService} from '../../../shared/services/param.service';
import {AuthService} from "../../../shared/services/auth.service";

// jQuery
declare var $: any;

function _window(): any {
    return window;
}

@Component({
    selector: 'points-cash-reward',
    templateUrl: './points-cash-reward.component.html',
    styleUrls: ['./points-cash-reward.component.scss']
})

export class PointsCashRewardComponent implements OnInit {
    public cashReward: RewardModel[] = [];
    public BsModalRef: BsModalRef = null;
    public rewardNewRefreshDisabled: boolean = false;
    @Input() freshPassUser;
    @Input() suspendedFreshPassUser;
    @Input() rewardsResponseObj;
    public bannerId: string;
    @Input() userInfo;
    @Input() currentEnv;
    @Input() appHostURL;
    @Input() enableCashReward: boolean;
    @Input() pointScoreCardFlow: boolean;
    @Output() toggleButtonStatus = new EventEmitter();
    @Output() renderGalleryComponent = new EventEmitter();
    banner: any;
    isAPICallInProgress = false;
    autoRewardsPoints: number;
    balance: number;
    dollarDiscount: number;
    willExpire: number;
    isUserHasRewards = false;
    pointsExpiryDate: any;
    points: any;
    rewardsPointsValueDetailsDisplay: any;
    rewardsPointsDateDetailsDisplay: any;
    cashRewardsOptin = false;
    isFuelSiteBanner: boolean = true;
    isFreshpassRebrand: boolean = false;
    freshpassText: string = '';
    foruBanner: string = '';
    nonFreshpassBanners: boolean;

    constructor(
        private _rewardService: RewardService,
        private _couponService: ClipService,
        public _rewardSummaryService: RewardsSummaryService,
        private modalService: BsModalService,
        private paramService: ParamService,
        private authService: AuthService
    ) {

    }

    ngOnInit() {
        this.isFuelSiteBanner = properties.rewardsConfig.fuelSiteBanner[this.banner];
        this.nonFreshpassBanners = this._rewardService.checkNonFreshpassBanners();
        this._couponService.apiResponse.subscribe(data => {

                this.isAPICallInProgress = data;

        })
        this._rewardSummaryService.$refreshCashRewardSection.subscribe(data => {
            if (data) {
                let scoreCardData = JSON.parse(localStorage.getItem('scoreCardDetails'));
                this.rewardsResponseObj = scoreCardData;
                this._init();
            }
        });
        this._init();
    }

    private _init() {
        this.banner = this.paramService.banner;
        this.isFuelSiteBanner = properties.rewardsConfig.fuelSiteBanner[this.banner];
        this.isFreshpassRebrand = properties.rewardsConfig.freshpassRebranding;
        this.freshpassText = properties.rewardsConfig.freshpassText;
        this.foruBanner = properties.rewardsConfig.foruBanner.replace('banner',properties.rewardsConfig.displaybleBannerNames[this.banner]);
        if (this.enableCashReward) {
            const galleryOffers = JSON.parse(localStorage.getItem('abRewards'));
            if (galleryOffers) {
                if (this.enableCashReward) {
                    this.cashReward = JSON.parse(localStorage.getItem('abRewards')).cashOffer;
                    if (this.cashReward && this.cashReward.length > 0 && this.cashReward[0].status === 'C') {
                        this.toggleButtonStatus.emit(true);
                    }
                }
                const rewardsObj = this.rewardsResponseObj;
                if (rewardsObj.rewards) {
                    const rewards = rewardsObj.rewards;
                    if (rewards == null || !rewards) {
                        this.autoRewardsPoints = 0;
                        this.balance = 0;
                        this.dollarDiscount = 0;
                        this.willExpire = 0;
                        this.points = null;
                        this.isUserHasRewards = false;

                    } else if (rewards.hasOwnProperty('balance')
                        && rewards.hasOwnProperty('autoRewardsPoints')
                        && rewards.hasOwnProperty('willExpire')) {

                        this.autoRewardsPoints = typeof rewards.autoRewardsPoints == 'number' ? rewards.autoRewardsPoints : 0;
                        this.balance = typeof rewards.balance == 'number' ? rewards.balance : 0;
                        this.dollarDiscount = typeof rewards.dollarDiscount == 'number' ? rewards.dollarDiscount : 0;
                        this.willExpire = typeof rewards.willExpire == 'number' ? rewards.willExpire : 0;
                        this.isUserHasRewards = rewards.isUserHasRewards;
                        if (this.isUserHasRewards && this.willExpire >= 0) {
                            const expireText = rewards.willExpire == 1 ? 'expires ' : 'expire ';
                            const dateAsOf = new Date();
                            let displayDate = new Date(dateAsOf.getFullYear(), dateAsOf.getMonth() + 1, 0);
                            this.rewardsPointsValueDetailsDisplay = rewards.willExpire == 1 ? rewards.willExpire.toLocaleString("en-US") + ' Point' : rewards.willExpire.toLocaleString("en-US") + ' Points';
                            this.rewardsPointsDateDetailsDisplay = expireText + displayDate.toLocaleString('default', {month: 'short'}) + ' ' + displayDate.getDate();
                        }
                    }
                } else {
                    this.autoRewardsPoints = 0;
                    this.balance = 0;
                    this.dollarDiscount = 0;
                    this.willExpire = 0;
                    this.isUserHasRewards = false;
                }
            }
        }

    }

    public setTopCashRewardText() {
        if (this.cashReward[0].status == 'U') {
            return 'Automatically convert Points into cash off at checkout';
        } else {
            return this.balance.toLocaleString("en-US") + ' Points';
        }
    }

    public toggleBtnActionClip(event) {
        $(".toggle").css('pointer-events', 'none');
        this.cashRewardsOptin = true;
        // when toggle switched to turned on. Passing status to parent component
        this.toggleButtonStatus.emit(event);
        this._couponService.apiResponseSource.next(true);
        // status: unclip action: clip (turn on cash reward)
        this._couponService.clipReward(this.cashReward[0], this.updateStatisticsMulticlip.bind(this), false, this.userInfo, this.currentEnv, true, this.pointScoreCardFlow, false);
        this.setAnalyticsLinkClick('rewards|cash-rewards-toggle-on', 'linkClick');

        // refresh reward and scorecard api
    }
    public toggleBtnActionUnclip(event) {
        $(".toggle").css('pointer-events', 'none');
        this.cashRewardsOptin = false;
        // when toggle switched to turned off. Passing status to parent component
        this.toggleButtonStatus.emit(event);
        this._couponService.apiResponseSource.next(true);
        // status: clip action: unclip (turn off cash reward)
        this._couponService.unclipReward(this.cashReward[0], this.updateStatisticsMulticlipUnclip.bind(this), false, this.userInfo, this.currentEnv, true, this.pointScoreCardFlow);
        this.setAnalyticsLinkClick('rewards|cash-rewards-toggle-off', 'linkClick');


        // refresh reward and scorecard api
    }
    private updateStatisticsMulticlipUnclip() {
        $(".toggle").css('pointer-events', 'auto');
        setTimeout(function(){
            (document.getElementById("toggle") as HTMLElement).focus();
        },500)
    }

    private updateStatisticsMulticlip() {
        $(".toggle").css('pointer-events', 'auto');
        setTimeout(function(){
            (document.getElementById("toggle") as HTMLElement).focus();
        },500)
    }

    public setRewardAmountText() {
        if (this.autoRewardsPoints === 0) {
            return '100 Points will automatically convert to save you ';
        } else if (this.autoRewardsPoints > 0) {
            return this.autoRewardsPoints.toLocaleString("en-US") + ' Points will automatically convert to save you ';
        }
        return null;
    }

    public setCashAmountText() {
        if (this.autoRewardsPoints === 0) {
            return '$1.00 at checkout';
        } else if (this.autoRewardsPoints > 0) {
            return '$' + this.dollarDiscount + '.00 at checkout'
        }
        return null;
    }

    public setExpireRewardSubText() {
        // let rewardsExpireDateString = this.rewardsExpireDate; // 2023-09-01
        // let rewardsExpireDate = new Date(rewardsExpireDateString + 'T00:00:00');
        // let today = new Date();
        // let timeDiff = Math.abs(rewardsExpireDate.getTime() - today.getTime());
        // let numOfDays = Math.round(timeDiff / (1000 * 60 * 60 * 24));
        // if (this.rewardsExpire > 0 && numOfDays <= 30 && numOfDays >= 0) {
        //     let rewardText = (this.rewardsExpire > 1 ? " Rewards expiring in " : " Reward expiring in ");
        //     let daysText = (numOfDays > 1 ? " days" : " day")
        //     return this.rewardsExpire + rewardText + numOfDays + daysText;
        // }
        // return null;
    }

    public setPointAmount() {
        if (this.autoRewardsPoints > 0) {
            return this.autoRewardsPoints + '/100 pts';
        }
        return '0/100 pts';
    }

    public setOptOutCashRewardText() {
        if (!this.isFuelSiteBanner) {
            return 'Opt out any time to use Points for grocery rewards.';
        } else {
            return 'Opt out any time to use Points for grocery rewards. You can still apply Points towards gas discounts.';
        }
    }

    public setOptOutCashRewardTextModal() {
        if (!this.isFuelSiteBanner) {
            return 'Opt out any time to use Points for grocery rewards.';
        } else {
            return 'Opt out any time to use Points for grocery rewards. You can still apply Points towards gas discounts.';
        }
    }

    openModal(template: TemplateRef<any>) {
        this.BsModalRef = this.modalService.show(template, {class: 'reward-modal-dialog'});
        this.trapFocus();
        this.setAnalyticsLinkClick('rewards|cash-rewards-learn-more', 'linkClick');
    }

    closeModal() {
        this.BsModalRef.hide();
        const modalElement = document.querySelector('#how-it-Works-Modal');
        modalElement.removeEventListener('keydown', this.handleKeyDown.bind(this));
        setTimeout(function(){
            (document.getElementById("learn-more-modal") as HTMLElement).focus();
        },1000)
    }

    trapFocus(){
        const modalElement = document.querySelector('#how-it-Works-Modal');
        const focusableElements = `button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])`;
        const firstFocusableElement = modalElement.querySelectorAll(focusableElements)[0];

        if (focusableElements.length){
            (firstFocusableElement as HTMLElement).focus();
            modalElement.addEventListener('keydown', this.handleKeyDown.bind(this));
        }
        
    }

    handleKeyDown(e: KeyboardEvent){
        const modalElement = document.querySelector('#how-it-Works-Modal');
        const focusableElements = `button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])`;
        const firstFocusableElement = modalElement.querySelectorAll(focusableElements)[0];
        const focusableContent = modalElement.querySelectorAll(focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1];

        let isTabPressed = e.key === `Tab` || e.keyCode === 9;
        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
              (lastFocusableElement as HTMLElement).focus(); // add focus for the last focusable element
              e.preventDefault();
            }
          } else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
              (firstFocusableElement as HTMLElement).focus(); // add focus for the first focusable element
              e.preventDefault();
            }
        }
    }

    public setAnalyticsLinkClick(linkName, analyticsEvent) {
        if (_window().AB?.DATALAYER) {
            const updatedLinkName = analyticsEvent === 'topNav' ? `cta:${_window().AB.DATALAYER.pathSections?.join(':')}|link|rewards:${linkName}` : linkName;
            if (linkName === 'get-fresh-pass') {
                localStorage.setItem('analyticsGetFreshPass', updatedLinkName);
            } else {
                _window().AB.DATALAYER.handleModalAndLinkEvents({modalAndLinkData : updatedLinkName, eventType : analyticsEvent});
            }
        }
    }

}
